import { withInstall } from '../_util/type';
import ColorPicker from './ColorPicker';
export default withInstall(ColorPicker);
